import { Dialog, FeedbackNotification } from '@ori-ui/components';
import { Subscription } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import { LogLevel, getLogger } from '@ori/checkout-utils';
import useTestId from '@ori/testid-generator';
import { useContext, useMemo } from 'react';

import { FormattedMessage } from '../components/FormattedMessage';
import { APP_NAME } from '../constants';
import { stateContext, wizardContext } from '../contexts';
import { useTranslations } from '../hooks/useTranslations';
import { Pages } from './pages';

const logDebug = getLogger(APP_NAME, LogLevel.Debug);

const ContentWrap = styled('div')(({ theme }) => ({
  minWidth: 200,
  padding: '3px',
  [theme.breakpoints.up('md')]: {
    width: 400,
  },
}));

export function SubscriptionWizard() {
  const { getTestIdProps } = useTestId();
  const { formatMessage } = useTranslations();
  const { handleCloseFeedback, isFeedbackOpen, open, onClose } = useContext(wizardContext);
  const { isBackEnabled, stepBack, currentStep } = useContext(stateContext);

  const CurrentPage = useMemo(() => Pages[currentStep], [currentStep]);

  const heading = useMemo(() => formatMessage('newSubscription'), [formatMessage]);

  logDebug('SubscriptionWizard currentStep: ', currentStep);

  return (
    <>
      <Dialog
        {...getTestIdProps(`subscription-wizard`)}
        disableEnforceFocus
        header={heading}
        showBackButton={isBackEnabled}
        open={open}
        onBack={stepBack}
        onClose={onClose}
      >
        <ContentWrap>{typeof CurrentPage === 'function' ? <CurrentPage /> : <div />}</ContentWrap>
      </Dialog>
      <FeedbackNotification
        open={isFeedbackOpen}
        icon={<Subscription />}
        onClose={handleCloseFeedback}
        {...getTestIdProps('subscription-wizard-feedback')}
      >
        <FormattedMessage id="subscribed" />
      </FeedbackNotification>
    </>
  );
}
